var map = {
	"./CHILD-DEVELOPMENT-CLINIC.jpg": 66419,
	"./COSMETIC-GYNAECOLOGY.jpg": 49391,
	"./GYNAECOLOGY.jpg": 79303,
	"./INFANT-CARE.jpg": 58683,
	"./LACTATION.jpg": 65742,
	"./LEVEL-3B-NICU.jpg": 15807,
	"./OBSTETRICS.jpg": 72059,
	"./PAEDIATRIC-HDU.jpg": 83412,
	"./RADIOLOGY.jpg": 86083,
	"./fertiloty.jpg": 8330,
	"./yoga-banner.jpg": 88050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48994;